import { Injectable } from '@angular/core';
import {
  Http,
  ConnectionBackend,
  RequestOptions,
  RequestOptionsArgs,
  Response,
  Headers,
  Request,
  XHRBackend
} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { HttpObject } from '../../enum/http-object.enum';
import { SessionService } from '../session/session.service';
import { HttpHeaderKey, CookiesKey } from '../../enum/http-header-key.enum';
import { CookiesService } from '../../service/cookies/cookies.service';


@Injectable()
export class HttpService extends Http {
 
  cookies : CookiesService;
  sessionSrv : SessionService;
  
  constructor(
    backend: ConnectionBackend,
    defaultOptions: RequestOptions,
    cookService : CookiesService,
    sessService : SessionService
  ) {
     
    super(backend, defaultOptions);
    this.cookies = cookService;
    this.sessionSrv = sessService;
  }

  /**
   * Performs a request with `get` http method.
   * @param url
   * @param options
   * @returns {Observable<>}
   */
  get(url: string, options?: RequestOptionsArgs): Observable<any> {
    this.beforeRequest();
 
    return super.get(this.getFullUrl(url), this.requestOptions(options))
      .catch(this.onCatch)
      .do((res: Response) => {
        this.onSuccess(res);
      }, (error: any) => {
      
        this.onError(error);
      })
      .finally(() => {
  
        this.onFinally();
      });
  }

  post(url: string,data : any, options?: RequestOptionsArgs): Observable<any> {
    this.beforeRequest();
 
    return super.post(this.getFullUrl(url),this.getData(data), this.requestOptions(options))
      .catch(this.onCatch)
      .do((res: Response) => {
        this.onSuccess(res);
      }, (error: any) => {
       
        this.onError(error);
      })
      .finally(() => {
  
        this.onFinally();
      });
  }
    
  // Implement POST, PUT, DELETE HERE

  /**
   * Request options.
   * @param options
   * @returns {RequestOptionsArgs}
   */
  private requestOptions(options?: RequestOptionsArgs): RequestOptionsArgs {
    if (options == null) {
      options = new RequestOptions();
    }
    if (options.headers == null) {
      options.headers = new Headers({
           'Authorization' : this.cookies.getCookies(CookiesKey.TOKEN.toString()),
           'Organization' : this.cookies.getCookies(CookiesKey.ORGANIZATION.toString()) 
      });
    }
    return options;
  }

  /**
   * Build API url.
   * @param url
   * @returns {string}
   */
  private getFullUrl(url: string): string {
    return  url;
  }
  private getData(data: any): any {
    return  data;
  }

  /**
   * Before any Request.
   */
  private beforeRequest(): void {
    
    if( this.cookies.getCookies(CookiesKey.TOKEN.toString())===''){
      if(this.sessionSrv !== undefined && this.sessionSrv !== null){
        this.sessionSrv.emitChange("expire");
      }
       
    }
    console.log("Request called");
    //this.notifyService.showPreloader();
  }

  /**
   * After any request.
   */
  private afterRequest(): void {
     console.log("afterRequest");
     
     /*let cookiesAuth = this.cookies.getCookies(CookiesKey.TOKEN.toString()).split(' ')[1];
     let cookiesTime = this.cookies.getCookies(CookiesKey.SESSIONTIME.toString());
     this.cookies.deleteCookie(CookiesKey.TOKEN.toString());
     this.cookies.deleteCookie(CookiesKey.SESSIONTIME.toString());
     this.cookies.setCookies(CookiesKey.TOKEN.toString(),cookiesAuth,+cookiesTime);
     this.cookies.setOtherCookies(CookiesKey.SESSIONTIME.toString(),cookiesTime,+cookiesTime);*/
    //this.notifyService.hidePreloader();
  }

  /**
   * Error handler.
   * @param error
   * @param caught
   * @returns {ErrorObservable}
   */
  private onCatch(error: any, caught: Observable<any>): Observable<any> {
    //this.notifyService.popError();
     
    return Observable.throw(error);
  }

  /**
   * onSuccess
   * @param res
   */
  private onSuccess(res: Response): void {
    console.log(res);
  }

  /**
   * onError
   * @param error
   */
  private onError(error: any): void {

   if(error.status===401) {
     this.cookies.deleteCookie(CookiesKey.TOKEN.toString());
     if(this.sessionSrv !== undefined && this.sessionSrv !== null){
      this.sessionSrv.emitChange("expire");
      
    }
      window.location.href="/admin/#/login";
   }
   // this.notifyService.popError();
  }

  /**
   * onFinally
   */
  private onFinally(): void {
    this.afterRequest();
  }
}


/*import { Injectable } from '@angular/core';
import {Http, XHRBackend, RequestOptions, Request, RequestOptionsArgs, Response, Headers} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
@Injectable()
export class HttpService extends Http {

  constructor (backend: XHRBackend, options: RequestOptions) {
    let token = localStorage.getItem('auth_token'); // your custom token getter function here
    options.headers.set('Authorization', `Bearer ${token}`);
    super(backend, options);
  }

  request(url: string|Request, options?: RequestOptionsArgs): Observable<Response> {
    debugger
    let token = localStorage.getItem('auth_token');
    if (typeof url === 'string') { // meaning we have to add the token to the options, not in url
      if (!options) {
        // let's make option object
        options = {headers: new Headers()};
      }
      options.headers.set('Authorization', `Bearer ${token}`);
    } else {
    // we have to add the token to the url object
      url.headers.set('Authorization', `Bearer ${token}`);
    }
    return super.request(url, options).catch(this.catchAuthError(this));
  }

  private catchAuthError (self: HttpService) {
     debugger
    // we have to pass HttpService's own instance here as `self`
    return (res: Response) => {
      console.log(res);
      if (res.status === 401 || res.status === 403) {
        // if not authenticated
        console.log(res);
      }
      return Observable.throw(res);
    };
  }
}*/


export function customHttpFactory (backend: XHRBackend, options: RequestOptions, cookiesService : CookiesService, sesService : SessionService) {
  return new HttpService(backend, options, cookiesService, sesService);
};
export var customHttpProvider = {
  provide: HttpService,
  useFactory: customHttpFactory,
  deps: [ XHRBackend, RequestOptions, CookiesService ]
  };


// WEBPACK FOOTER //
// ./src/app/shared/service/http/interceptor-service.service.ts